var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "AddTicketModal",
      "modal-class": "ticket_modal",
      "centered": "",
      "size": "lg",
      "hide-footer": "",
      "hide-header-close": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("New Ticket")])]), _c('p', {
    staticClass: "clr-bold-grey"
  }, [_vm._v(" Please fill the form below to submit your ticket. ")]), _c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.submit);
            }
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('div', {
          staticClass: "col-md-12 mb-3"
        }, [_c('input-text', {
          attrs: {
            "vmodel": _vm.form.phone,
            "label-for": "phone",
            "labelName": "Phone",
            "input-class": "custom-input mt-1",
            "rules": {
              required: true
            }
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "phone", $event);
            }
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('div', {
          staticClass: "col-md-6 mb-3"
        }, [_c('input-text', {
          attrs: {
            "vmodel": _vm.form.subject,
            "label-for": "subject",
            "labelName": "Subject",
            "input-class": "custom-input mt-1",
            "rules": {
              required: true
            }
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "subject", $event);
            }
          }
        })], 1), _c('div', {
          staticClass: "col-md-6 mb-3 category-selectwrapper"
        }, [_c('input-multi-select', {
          attrs: {
            "vmodel": _vm.form.category_id,
            "label-for": "category",
            "labelName": "Category",
            "options": _vm.categories.length ? _vm.categories.map(function (item) {
              return item.id;
            }) : [],
            "custom-label": _vm.categories.length ? function (id) {
              return _vm.categories.find(function (item) {
                return item.id == id;
              }).name;
            } : function () {},
            "active-data": _vm.categories,
            "rules": {
              required: true
            }
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "category_id", $event);
            }
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('div', {
          staticClass: "col-12 mb-3"
        }, [_c('input-quill-editor', {
          attrs: {
            "vmodel": _vm.form.message,
            "label": "Message",
            "rules": {
              required: true
            },
            "placeholder": "Add your message here ...",
            "formGroupClass": "editorInputWrapper"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "message", $event);
            }
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row uploadFilewrapper"
        }, [_c('div', {
          staticClass: "col-12 col-lg-6"
        }, [_c('input-file-multiple', {
          attrs: {
            "vmodel": _vm.form.issue_document,
            "label-name": "Upload Document",
            "label-for": "document",
            "rules": {
              required: false
            }
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "issue_document", $event);
            }
          },
          scopedSlots: _vm._u([{
            key: "uploadedFiles",
            fn: function fn() {
              return undefined;
            },
            proxy: true
          }], null, true)
        })], 1), _c('span', {
          staticClass: "font-13 d-inline-block  clr-bold-grey upload-file-type"
        }, [_vm._v("Allowed file types : jpeg,png,jpg,gif,svg,pdf,xls,xlsx,doc,docx,csv & txt")])]), _c('div', {
          staticClass: "button-wrapper d-flex justify-content-end mt-3 align-items-center gap-3"
        }, [_c('button', {
          staticClass: "btn cancel-btn btn-secondary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_vm._v(" Cancel ")]), _c('b-button', {
          staticClass: "univ-btn",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v(" Save ")])], 1)])];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }